<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12" ref="loader">
                <h1>{{title}} <small class="small text-wellis-gold">[{{$t('components.stocklist.title')}}]</small></h1>
                <div class="row">
                    <div class="wos__content container-fluid bg-white shadow">
                        <section class="mb-5">
                            <div class="row mt-4 border-bottom" v-if="hasProduct">
                                <div class="col-sm-12">
                                    <router-link :to="{name:'app.stocklist'}" class="btn btn-wos-real btn-sm" v-if="!isTransit">
                                        {{$t('components.stocklist.title') | capitalize}}
                                    </router-link>
                                    <router-link :to="{name:'app.stocklist.transit'}" class="btn btn-wos-real btn-sm" v-else>
                                        {{`${$t('components.stocklist.title')} ${$t('components.stocklist-transit.title')}` | capitalize}}
                                    </router-link>
                                    <hr>
                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-12 col-md-5 border-right">
                                            <Gallery :data="productImages" v-if="productImages.length > 0"/>
                                        </div>
                                        <div class="col-sm-12 col-md-7">
                                            <h3 class="h3 text-wellis-gold">{{product.catalogNo}}</h3>
                                            <h5 class="h5 text-wellis-gold text-muted">{{product.name}}</h5>
                                            <div class="mt-3 border-top">
                                                <p class="lead font-weight-bold">{{$t('components.products.description') | capitalize}}</p>
                                                <div v-if="product.description !== null">
                                                    <div v-html="nl2br(product.description)"></div>
                                                </div>
                                                <p v-else>
                                                    {{$t('components.products.no-description')}}
                                                </p>
                                                <hr>
                                            </div>
                                            <div v-if="hasPrice">
                                                <p class="lead font-weight-bold" v-if="product.price !== null">{{$t('components.products.price') | capitalize}}</p>
                                                <div v-if="discount > 0">
                                                    <div v-if="discount > 0">
                                                        <p class="m-0 text-wellis-gold font-weight-bold font-italic">{{discount}} %
                                                            {{$t('components.products.discount') | capitalize}}</p>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12" v-if="hasVat">
                                                            <small class="text-line-through mr-5">
                                                                {{factoryPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                                                            </small>
                                                            <small class="text-line-through">
                                                                {{factoryPrice | toPrice(currency, hasVat)}}
                                                            </small>
                                                        </div>
                                                        <div class="col-sm-12" v-else>
                                                            <small class="text-line-through">
                                                                {{factoryPrice | toPrice(currency, hasVat)}}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-sm-12" v-if="hasVat">
                                                            <small class="text-wellis-gold font-weight-bold mr-5">
                                                                {{unitPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                                                            </small>
                                                            <p class="d-inline text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                                                        </div>
                                                        <div class="col-sm-12" v-else>
                                                            <p class="d-inline text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="row">
                                                        <div class="col-sm-12 col-md-6" v-if="hasVat">
                                                            <small class="text-wellis-gold font-weight-bold mr-5">
                                                                {{unitPrice | toPrice(currency, false)}} + {{$t('components.products.vat')}}
                                                            </small>
                                                            <p class="text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                                                        </div>
                                                        <div class="col-sm-12 col-md-6" v-else>
                                                            <p class="text-wellis-gold end-price">{{unitPrice | toPrice(currency, hasVat)}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-3 border-top">
                                                <p class="lead font-weight-bold">{{$t('components.stocklist.warehouse') | capitalize}}</p>
                                                <p class="text-wellis-gold font-weight-bold end-price">
                                                    {{warehouse}}
                                                </p>
                                            </div>
                                            <div class="mt-3 border-top">
                                                <p class="lead font-weight-bold">{{$t('components.stocklist.sum-quantity') | capitalize}}</p>
                                                <p class="text-wellis-gold font-weight-bold quantity">
                                                    {{product.quantity}} {{product.unit}}
                                                </p>
                                                <hr>
                                            </div>
                                            <p class="lead font-weight-bold">{{$t('components.stocklist.configuration') | capitalize}}</p>
                                            <div class="container">
                                                <table class="table  table-striped">
                                                    <tr class="font-weight-bold" v-for="item in product.configuration" :key="item.description">
                                                        <td class="text-muted">{{item.description}}</td>
                                                        <td class="text-wellis-gold">{{selectedOptionValueDescription(item)}}</td>
                                                    </tr>
                                                </table>
                                            </div>
                                            <div class="row" v-if="product.quantity > 0">
                                                <!--<div class="col-sm-12 col-md-4" >
                                                    <router-link v-if="!isTransit" :to="{name: 'app.configurator',
                                                        params: {productIdentifier: `${product.catalogNo}&${product.configNo}&${warehouse}`},
                                                        query: {host: 'STOCK_FIFO'}}" class="btn btn-wos-real w-100 mt-5 mb-2">
                                                        {{$t('components.stocklist.start-config')}}
                                                    </router-link>
                                                    <router-link v-else :to="{name: 'app.configurator',
                                                        params: {productIdentifier: $route.params.uniqueId},
                                                        query: {host: 'STOCK_ETA'}}" class="btn btn-wos-real w-100 mt-5 mb-2">
                                                        {{$t('components.stocklist.start-config')}}
                                                    </router-link>
                                                </div>-->
                                                <div class="col-sm-12 col-md-6">
                                                    <div>
                                                        <button class="btn btn-sm btn-wellis-gold text-white" @click="decreaseQuantity">
                                                            -
                                                        </button>
                                                        <input type="number" class="quantity-input invisible-select" v-model="quantity">

                                                        <button type="button" class="btn btn-sm btn-wellis-gold text-white" @click="increaseQuantity">
                                                            +
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 col-md-6">
                                                    <button class="btn btn-wos-real w-100 mt-5 mb-2" @click="addCart">
                                                        {{$t('components.products.availability.btnAddCart')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="container-fluid bg-white shadow mt-3" v-if="requiredProducts.length > 0 || suggestedProducts.length > 0">
                        <div class="row">
                            <div class="col-sm-12">
                                <h3>{{$t('components.products.related.title')}}</h3>
                                <div class="card card-body">
                                    <div v-if="requiredProducts.length > 0">
                                        <h4 class="border-bottom">{{$t('components.products.related.required')}}</h4>
                                        <div class="row">
                                            <div class="col-sm-12 col-lg-3 col-md-6" v-for="(item, index) in requiredProducts" :key="index">
                                                <ProductCard :product="item"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="suggestedProducts.length > 0">
                                        <hr class="mt-3 mb-3">
                                        <h4>{{$t('components.products.related.suggested')}}</h4>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3" v-for="(item, index) in suggestedProducts" :key="index">
                                                <ProductCard :product="item"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StocklistApiService from "../../../api/stocklist.api";
import {EVENT_CART_COUNT_UPDATE, EVENT_LANG_CHANGE} from "../../../core/constants";
import Gallery from "../ProductGallery";
import ProductCard from "../ProductCard";
import {empty, nl2br} from "../../../helpers";
import CartApiService from "@/api/cart.api";

export default {
    name: "StocklistDetails",

    components: {Gallery, ProductCard},

    mounted() {
        this.fetch();
        this.$eventBus.$on(EVENT_LANG_CHANGE, () => {
            this.fetch();
        });
    },

    destroyed() {
        this.$eventBus.$off(EVENT_LANG_CHANGE);
    },

    data() {
        return {
            productData: null,
            quantity: 1,
        }
    },

    methods: {
        fetch() {
            let loader = this.$loading.show();
            if (this.$route.name === 'app.stocklist.view') {
                StocklistApiService.configurationDetails(this.$route.params.catalogNo, this.$route.params.configNo, this.$route.params.warehouse, {
                    "with_media": true,
                    "with_configuration": true,
                    "with_related": true
                }).then(response => {
                    this.productData = response.data.product;
                    this.quantity = this.productData.quantity;
                })
                    .catch(() => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('api-error')
                        });
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            } else {
                StocklistApiService.transitDetails(this.$route.params.uniqueId, {
                    "with_media": true,
                    "with_configuration": true,
                    "with_related": true
                }).then(response => this.productData = response.data.product)
                    .catch(() => {
                        this.$swal.fire({
                            icon: "error",
                            allowOutsideClick: false,
                            html: this.$t('api-error')
                        });
                    })
                    .finally(() => {
                        loader.hide();
                        loader = null;
                    });
            }
        },

        increaseQuantity() {
            this.quantity++;
            if (this.quantity > this.product.quantity) {
                this.quantity = this.product.quantity;
            }
        },

        decreaseQuantity() {
            this.quantity--;
            if (this.quantity < 1) {
                this.quantity = 1;
            }
        },

        addCart() {
            let loader = this.$loading.show();
            let attributes = {
                "coordinator": "addProductConfiguration",
                "product": this.isTransit
                    ? this.product.uniqueId
                    : `${this.product.catalogNo}&${this.product.configNo}&${this.product.warehouse}`,
                "quantity": this.quantity,
                "host": this.isTransit ? 'STOCK_ETA' : 'STOCK_FIFO',
                "configurations": {}
            };

            CartApiService.add(attributes)
                .then(response => {
                    this.$eventBus.$emit(EVENT_CART_COUNT_UPDATE, response.data.count);
                    this.productData.quantity -= this.quantity;
                    this.quantity = this.product.quantity;
                })
                .catch(error => {
                    if (error.response.data.exception) {
                        if (error.response.data.exception.class === 'DifferentWarehouseException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-warehouse')
                            });
                        }

                        if (error.response.data.exception.class === 'DifferentStocklistTypeException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-type')
                            });
                        }

                        if (error.response.data.exception.class === 'UnavailableQuantityException') {
                            this.$swal.fire({
                                zIndex: 9999,
                                icon: "error",
                                html: this.$t('components.cart.unavailable-quantity')
                            });
                        }
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            html: this.$t('components.cart.add-cart-error')
                        });
                    }
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },
    },

    computed: {

        title() {
            if (this.productData === null) {
                return this.$route.params.catalogNo;
            }

            return this.productData.name;
        },

        discount() {
            if (this.productData === null || this.productData.price === null) {
                return 0;
            }

            return this.productData.price.discount;
        },

        hasProduct() {
            return this.productData !== null;
        },

        product() {
            return this.productData;
        },

        productImages() {
            if (this.productData === null) {
                return [];
            }
            return this.productData.media.imageUrls;
        },

        hasPrice() {
            return this.productData.price !== null;
        },


        unitPrice() {
            if (this.productData.price === null) {
                return 0;
            }
            return this.productData.price.unitPrice;
        },

        factoryPrice() {
            if (this.productData.price === null) {
                return 0;
            }
            return this.productData.price.factoryPrice;
        },

        currency() {
            if (this.productData.price === null) {
                return null;
            }
            return this.productData.price.currency;
        },

        hasVat() {
            if (this.productData.price === null) {
                return null;
            }
            return this.productData.price.vat;
        },

        requiredProducts() {
            if (!this.productData || !this.product.relatedProducts) {
                return [];
            }
            return this.productData.relatedProducts.required;
        },

        suggestedProducts() {
            if (!this.productData || !this.product.relatedProducts) {
                return [];
            }
            return this.productData.relatedProducts.suggested;
        },

        selectedOptionValueDescription() {
            return item => {
                if (item.values) {
                    let line = item.values.find(x => x.optionValueId === item.selectedValue);
                    if (line) {
                        return line.description ?? item.selectedValue + ' *';
                    }
                    return item.selectedValue + ' *';
                }
            }
        },

        warehouse() {
            return this.productData.warehouse;
        },

        isTransit() {
            return !empty(this.productData.eta);
        },

        nl2br() {
            return value => nl2br(value);
        }
    }
}
</script>

<style scoped>
.small {
    font-size: 16px;
}

.end-price {
    font-size: 26px;
    font-weight: bold;
}

.lead {
    margin-bottom: 5px;
}


.quantity {
    animation: quantity-blinker 1s linear infinite;
    font-size: 20px !important;
}

@keyframes quantity-blinker {
    50% {
        opacity: 0.4;
    }
}

.quantity-input {
    padding-top: 50px;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    border-bottom: 1px solid;
    border-radius: 0;
    width: 75%;
    font-size: 22px;
}
</style>
